import { makeStyles } from '@fluentui/react-components';

export const useContainerSearchItemsStyles = makeStyles({
    skeleton: {
        marginBottom: '10px',
    },
    skeletonItem: {
        height: '30px',
        width: '100%',
    },
});
